import { Outlet } from 'react-router-dom'
import { SystezaLogo } from '../ui'

export default function AuthLayout() {
  return (
    <div className="min-h-screen flex" style={{ background: '#020818' }}>
      {/* Grid BG */}
      <div className="fixed inset-0 pointer-events-none" style={{
        backgroundImage: 'linear-gradient(rgba(26,106,245,0.03) 1px,transparent 1px),linear-gradient(90deg,rgba(26,106,245,0.03) 1px,transparent 1px)',
        backgroundSize: '64px 64px',
      }} />
      {/* Radial glow */}
      <div className="fixed top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] pointer-events-none"
        style={{ background: 'radial-gradient(ellipse,rgba(0,200,232,0.07) 0%,transparent 70%)' }} />

      <div className="relative flex-1 flex flex-col items-center justify-center px-4 py-12">
        {/* Logo */}
        <div className="flex items-center gap-3 mb-10">
          <SystezaLogo size={40} />
          <span className="font-display font-extrabold text-2xl tracking-tight text-white">SYSTEZA</span>
        </div>
        {/* Form card */}
        <div className="w-full max-w-md rounded-2xl p-8 border"
          style={{ background: '#040E2A', borderColor: '#1A2F60' }}>
          <Outlet />
        </div>
        <p className="mt-6 text-[11px] font-mono text-[var(--text-dim)] tracking-widest">
          UNIFIED INFRASTRUCTURE · AUTOMATION · GROWTH
        </p>
      </div>
    </div>
  )
}
